export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_11.38bf1366.jpg";